import { FunnelX, Search } from 'lucide-react'
import { useTranslate } from 'shared/lib/i18n'

/** Design 2a search field: 44px rounded, tertiary fill, hint icon + placeholder. */
export function SearchBar({
	value,
	onChange,
	hasFilters,
	onClearFilters,
}: {
	value: string
	onChange: (v: string) => void
	hasFilters?: boolean
	onClearFilters?: () => void
}) {
	const { prefixT } = useTranslate('pages.feed')
	return (
		<div className="relative mt-4 flex h-11 items-center gap-2 rounded-xl bg-[var(--tgui--tertiary_bg_color,rgb(42,42,42))] px-3.5">
			<Search className="size-5 shrink-0 text-[var(--tgui--hint_color,rgb(170,170,170))]" />
			<input
				type="search"
				inputMode="search"
				value={value}
				onChange={(e) => onChange(e.target.value)}
				placeholder={prefixT('searchPlaceholder')}
				className="min-w-0 flex-1 bg-transparent text-[17px] text-[var(--tgui--text_color,#fff)] placeholder:text-[var(--tgui--hint_color,rgb(170,170,170))] focus:outline-none [&::-webkit-search-cancel-button]:hidden"
			/>
			{hasFilters && (
				<button
					type="button"
					onClick={onClearFilters}
					aria-label={prefixT('resetFilters')}
					className="flex size-7 shrink-0 items-center justify-center rounded-lg text-[var(--tgui--link_color,rgb(41,144,255))] transition-transform active:scale-90 hover:opacity-80"
				>
					<FunnelX className="size-5" />
				</button>
			)}
		</div>
	)
}
